import { InjectionToken } from '@angular/core';
import { PmsStempelTerminalConfiguration } from './types/stempel-terminal-configuration';

export const SOFTLINE_FEATURE_PMS_STEMPELTERMINAL_STEMPEL = 'pms/stempel-terminal/stempel'
export const SOFTLINE_FEATURE_PMS_STEMPELTERMINAL_TAGESUEBERSICHT = 'pms/stempel-terminal/tagesuebersicht'
export const SOFTLINE_FEATURE_PMS_STEMPELTERMINAL_SPEZIALSTEMPEL = 'pms/stempel-terminal/spezial-stempel'
export const SOFTLINE_FEATURE_PMS_STEMPELTERMINAL_STEMPELCODE = 'pms/stempel-terminal/stempel-code'

export const SOFTLINE_CONFIG_PMS_STEMPELTERMINAL_CONFIG = new InjectionToken<PmsStempelTerminalConfiguration>('SOFTLINE_CONFIG_PMS_STEMPELTERMINAL_CONFIG');
export const SOFTLINE_CONFIG_TERMINAL_PASSWORT = new InjectionToken<string>('SOFTLINE_CONFIG_TERMINAL_PASSWORT');

